import { Form, Modal } from 'react-bootstrap'
import './Success_Modal.css'
import Green_Check_Lottie from '../../../Animation/green_check_lottie/Green_Check_Lottie';

const Success_Modal = (props) => {

    setTimeout(() => {
        props?.onHide()
    }, 5000);

    return (
        <Modal className="Success_Modal" size='sm' {...props} centered>

            <div className='absolute_div'>
                <div className='animation_holder'>
                    <Green_Check_Lottie />
                </div>
            </div>

            <Modal.Body>
                <p className='success_text'>{props?.successText}</p>
            </Modal.Body>


        </Modal>
    )
}

export default Success_Modal
